/* global Sys, Core */
Sys.ns("Core.Slots");

/**
 * The Free Rounds model.
 *
 * @class Core.Slots.FreeRoundsModel
 * @extends Core.Model
 */
Core.Slots.FreeRoundsModel = {

    constructor: function() {
        Core.Slots.FreeRoundsModel.superclass.constructor.apply(this, arguments);
    },

    /**
     * @protected
     * @inheritdoc
     */
    setupData: function() {
        this.storeData("hasShownSplash", false);
    }
};

Core.Slots.FreeRoundsModel = Sys.extend(Core.Model, Core.Slots.FreeRoundsModel, "Core.Slots.FreeRoundsModel");
